import React from 'react'

import Dico from '../../helpers/Dico'

const LegalMentions = ({ data }) => (

	<div className="row shadow rounded">
		{data.legalNotice != null && data.legalNotice.map((line, index) => (
			<h6 key={index}>{Dico.getRichText(line.text)}</h6>
		))}
		<br />
		{data.legalMention != null && data.legalMention.map((line, index) => (
			<p key={index} style={Dico.getStyle(line.style, true)}>
				<small>
					{Dico.getRichText(line.text)}
					{line.text.length === 0 && <br />}
				</small>
			</p>
		))}
	</div>
)

export default LegalMentions
